/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { observer } from 'mobx-react';
import React, { Component } from 'react';
import uuid from 'uuid';
import './layout.scss';

const renderLayout = ({ imageList }) => imageList.map(image => <div className="banner-image" style={{ backgroundImage: `url('${image}')` }} />);

@observer
class ImageOnlyLayout extends Component {
    renderGuid = uuid.v4();

    componentDidMount() {
        const { bannerItem, appConfig, appsSkeletonModel } = this.props;
        const {
            analytics,
            analytics: { bannerAnalyticsCallback },
            name,
        } = bannerItem;

        bannerAnalyticsCallback('bannerRendered',
            {
                analytics,
                CTAText: null,
                name,
                renderGuid: this.renderGuid,
            },
            appConfig,
            appsSkeletonModel);
    }

    render() {
        const { bannerItem } = this.props;
        const {
            imageList,
        } = bannerItem;
        return (
            <div
                className="image-only-layout"
                render-guid={this.renderGuid}
            >
                {renderLayout({ imageList })}
            </div>
        );
    }
}

export default ImageOnlyLayout;
